export const WORD_CONTEXT_MENU_ID = "word-context-menu-id";
